import { Functions, httpsCallable } from "firebase/functions";

export type LoginCodeChannel = "sms" | "email";

export interface RequestLoginCodePayload {
  /** Whatever the student typed: email or phone, any formatting. */
  identifier: string;
}

export interface RequestLoginCodeResponse {
  /** Where the code went — drives the "check your texts/email" copy. */
  channel: LoginCodeChannel;
  /** How long the code stays valid, in seconds. */
  ttlSeconds: number;
}

/**
 * Calls the `requestLoginCode` backend callable, which looks up the account
 * behind an email or phone number and sends it a one-time sign-in code.
 * Failures surface as `FirebaseError`s. UI callers translate the stable
 * `details.reason` metadata rather than rendering backend text directly.
 */
export default async function requestLoginCode(
  payload: RequestLoginCodePayload,
  functions: Functions
): Promise<RequestLoginCodeResponse> {
  const callable = httpsCallable<
    RequestLoginCodePayload,
    RequestLoginCodeResponse
  >(functions, "requestLoginCode");
  const result = await callable(payload);
  return result.data;
}
